import React, { Component } from "react";
import Layout from "../Layout";

import { Button, Input, Textarea, Select } from "~/js/partials";
import { isInitialValid } from "~/js/utils";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import numeral from "numeral";
import { formsService } from "~/js/_services";
import {
    calculatePricePerWeek,
    calculateTotalInterest,
} from "../../../utils/calculatePricePerWeek";

const vehicle = window.current_vehicle ?? null;
const dealer = window.current_dealer ?? null;
const MAX_INTEREST_YEARS = 5;
const MIN_INTEREST_RATE = 9.45;
const MAX_INTEREST_RATE = 14.15;


const termsEl = document.querySelector(".vehicle-finance-terms");

class FormVehicleFinanceCalculator extends Component {
    constructor(props) {
        super(props);
        this.depositRef = React.createRef();
        this.detailsRef = React.createRef();
        this.financeRef = React.createRef();
        this.yearsRef = React.createRef();

        this.state = {
            repayments: 0,
            vehiclePrice: this.priceFilter(window.current_total_price ?? 0),
            deposit:  this.priceFilter((window.current_total_price * 0.35)), // original using 35% of vehicle price
            years: MAX_INTEREST_YEARS,
            financeRate: 11.95,
            currentStep: 1,
            fees: 518.39,
        };

        // const pm = 591.5;
        // const total = 83922;
        // let l = total;
        // const intr = 8.99;
        // let payed = 0;
        // let weeks = 0;

        // while (l > 0) {
        //     const i = ((total / 100) * intr) / 52;
        //     l -= pm - i;
        //     weeks++;
        //     payed += pm;
        // }

        // console.log(l, payed, weeks, weeks / 52);
    }

    componentDidMount() {
        this.calcPrice(true);
    }

    handleSubmit = (fields, { setStatus, setSubmitting }) => {
        const { showSuccessPopup, type } = this.props;

        // Reset status, if there where errors
        setStatus();

        let data = {
            name: "Vehicle Finance Enquiry",
            fields: JSON.parse(JSON.stringify(fields)),
        };

        data.vehicle = vehicle
            ? `${vehicle["@LISTING_SEQ"]} (${vehicle["@LISTING_TITLE"]})`
            : null;
        data.dealer = dealer
            ? `${dealer.data.autoplay.dealer} (${dealer.post_title})`
            : null;
        data.fields.formDealerID = window.current_dealer["ID"];
        data.repayments = this.state.repayments;

        formsService.makeAnEnquiry(data).then(
            (success) => {
                const title = "Your submission is successful";
                const text = "We will contact you about your booking.";
                showSuccessPopup({ title, text });
                setSubmitting(false);

                let formType = `vehicle-finance-enquiry-${vehicle["@LISTING_SEQ"]}`;
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: "FormSubmit",
                    formType: formType,
                    formBrand: vehicle ? vehicle["@LISTING_MAKE"] : null,
                    formModel: vehicle ? vehicle["@LISTING_MODEL"] : null,
                    formRegion: null,
                    formDealership: data.dealer ? data.dealer : null,
                    formKm0: vehicle ? vehicle["@LISTING_ODOMETER"] : null,
                    formVehicleRegistration: vehicle
                        ? vehicle["@LISTING_STOCK_NO"]
                        : null,
                });
            },
            (error) => {
                setSubmitting(false);
                setStatus(error.message);
            }
        );
    };

    priceFilter = (value) => {
        value = value.toString().replace(',', "");

        if (value !== "") {
            value = numeral(value).format("0,0");
        }
        return value;
    };

    yearsFilter = (value) => {
        let yearsFilter = value.toString().replace(/\D/, "");
        if(yearsFilter > MAX_INTEREST_YEARS){
            return MAX_INTEREST_YEARS;
        }else{
            return yearsFilter;
        }
    };

    rateFilter = (value) => {
        // console.log('before', value);
        value = value.toString().replace(/[^\d*\.\d+]/, "");
        // console.log('after', value);

        // if (value !== '') {
        //     value = numeral(value).format('0,0.0');
        // }

        if(value > 13){
            value = 12.45;
        }
        return value;
    };

    calcPrice = (first = false) => {
        let { vehiclePrice, repayments, fees } = this.state;
        let deposit = parseInt(this.state.deposit.replaceAll(",", ""), 10);
        if(isNaN(deposit)){
            deposit = 0;
        }
        if(deposit > parseInt(this.state.vehiclePrice.replaceAll(",", ""), 10)){
            deposit = parseInt(this.state.vehiclePrice.replaceAll(",", ""), 10);
        }
        vehiclePrice = parseInt(vehiclePrice.replaceAll(",", ""), 10) + 518.39;

        let fLoanAmount = Math.round(vehiclePrice - deposit, 2); //+ fees;

        let fAPR = parseFloat(this.state.financeRate);

        if(fAPR < MIN_INTEREST_RATE || isNaN(fAPR)){
            fAPR = MIN_INTEREST_RATE;
        }
        if(fAPR > MAX_INTEREST_RATE){
            fAPR = MAX_INTEREST_RATE;
        }

        let iTerm = parseInt(this.state.years, 10);
        if(iTerm > MAX_INTEREST_YEARS){
            iTerm = MAX_INTEREST_YEARS;
        }
        if(iTerm === 0 || isNaN(iTerm)){
            iTerm = 1;
        }

        let output = calculatePricePerWeek(fLoanAmount, fAPR, iTerm);
        let totalInterest = calculateTotalInterest(fLoanAmount, fAPR, iTerm);

        if(totalInterest > calculateTotalInterest(fLoanAmount, fAPR, MAX_INTEREST_YEARS)){
            totalInterest = calculateTotalInterest(fLoanAmount, fAPR, MAX_INTEREST_YEARS);
        }
        if(totalInterest == 0 || isNaN(totalInterest)){
            totalInterest = calculateTotalInterest(fLoanAmount, MIN_INTEREST_RATE, MAX_INTEREST_YEARS);
        }
        // console.log(totalInterest);

        if (repayments != Math.ceil(output, 0)) {
            this.setState({ repayments: Math.ceil(output, 0) });
        }
    };

    renderForm = (props) => {
        const { repayments, vehiclePrice, deposit, years, fees } = this.state;
        const dealer = window.current_dealer ?? null;
        const currentFinanceOffer = window.finance_offer ?? null;


        let iDeposit = parseInt(deposit.replaceAll(",", ""), 10);
        if(isNaN(iDeposit)){
            iDeposit = 0;
        }
        if(iDeposit > parseInt(vehiclePrice.replaceAll(",", ""), 10)){
            iDeposit = parseInt(vehiclePrice.replaceAll(",", ""), 10);
        }
        const iVehiclePrice = parseInt(vehiclePrice.replaceAll(",", ""), 10);
        const iLoanAmount = parseInt(
            Math.round(iVehiclePrice - iDeposit, 2),
            10
        );

        let iYears = parseInt(years);
        if(iYears > MAX_INTEREST_YEARS){
            iYears = MAX_INTEREST_YEARS;
        }
        if(iYears == 0 || isNaN(iYears)){
            iYears = 1;
        }


        const totalFees = fees;
        const totalPayback = repayments * 52 * iYears;

        const min_interest = MIN_INTEREST_RATE;
        const max_interest = MAX_INTEREST_RATE;

        const totalInterest = totalPayback - iLoanAmount;


        const total = totalPayback + iDeposit + totalFees;
        // console.log(totalPayback, iLoanAmount, repayments, iYears);

        return (
            <Form className="popup-form__form">
                <div className="calculator calculator--vehicle">
                    <div className="calculator__details" ref={this.detailsRef}>
                        <div className="calculator__h">
                            Repayments calculator
                        </div>
                        <div className="calculator__field">
                            <div className="calculator__label">
                                Vehicle Price
                            </div>

                            {(() => {
                                if (vehicle) {
                                    return (
                                        <Input
                                            name={`vehiclePrice`}
                                            placeholder={` Price`}
                                            modifiers={["form", "price-2"]}
                                            disabled={true}
                                            form={props}
                                        />
                                    );
                                } else {
                                    return (
                                        <Input
                                            name={`vehiclePrice`}
                                            placeholder={` Price`}
                                            modifiers={[
                                                "form",
                                                "price-2",
                                                "has-default",
                                            ]}
                                            // disabled={true}

                                            form={props}
                                            valueFilter={this.priceFilter}
                                            onChange={(e) => {
                                                this.setState(
                                                    {
                                                        vehiclePrice:
                                                        e.target.value,
                                                    },
                                                    () => {
                                                        this.calcPrice();
                                                    }
                                                );
                                            }}
                                        />
                                    );
                                }
                            })()}
                        </div>

                        <div className="calculator__field">
                            <div className="calculator__label">Deposit</div>
                            <Input
                                name={`deposit`}
                                placeholder={` Deposit`}
                                modifiers={["form", "price-2", "has-default"]}
                                ref={this.depositRef}
                                form={props}
                                valueFilter={this.priceFilter}
                                onChange={(e) => {
                                    this.setState(
                                        { deposit: e.target.value },
                                        () => {
                                            this.calcPrice();
                                        }
                                    );
                                }}
                            />
                        </div>

                        <div className="calculator__field">
                            <div className="calculator__label">
                                Loan Term In Years
                            </div>
                            <Input
                                name={`years`}
                                placeholder={`Years`}
                                modifiers={["form", "rate", "has-default"]}
                                form={props}
                                ref={this.yearsRef}
                                valueFilter={this.yearsFilter}
                                onChange={(e) => {
                                    this.setState(
                                        { years: e.target.value },
                                        () => {
                                            this.calcPrice();
                                        }
                                    );
                                }}
                            />
                        </div>

                        <div className="calculator__field calculator__field--percentage">
                            <div className="calculator__label">
                                Estimated fixed annual interest rate
                            </div>
                            <Input
                                name={`financeRate`}
                                placeholder={`Rate`}
                                // suffix={`%`}
                                modifiers={["form", "rate", "has-default"]}
                                form={props}

                                ref={this.financeRef}
                                valueFilter={this.rateFilter}
                                onChange={(e) => {
                                    this.setState(
                                        { financeRate: e.target.value },
                                        () => {
                                            this.calcPrice();
                                        }
                                    );
                                }}
                            >
                                <span className="calculator__field__suffix">
                                    %<span> p.a. fixed for the term</span>
                                </span>
                            </Input>
                        </div>
                        <span className="calculator__panel-ts">
                            <p>Our interest rates may vary from <br />
                                {(min_interest).toFixed(2)}% pa - {(max_interest).toFixed(2)}% pa, for a fixed term.</p>
                        </span>


                        <div className="popup-form__submit" data-model-prefill="" data-controller="popup-form" data-form="finance-enquiry">
                            <Button
                                title={`Enquire about Finance`}
                                modifiers={["solid", "medium", "full"]}
                                chevron={true}
                            />
                        </div>

                        {vehicle && (
                            <div className="popup-form__submit">
                                <Button
                                    extraClass="form-finance-calculator"
                                    target={"_blank"}
                                    title={`Apply for finance`}
                                    // title={`Apply for Standard Finance`}
                                    modifiers={["solid", "medium", "full"]}
                                    href={`https://digital.heartland.co.nz/#/apply-for-armstrongs-finance/armstrongs-car-loan-calculator?pc=${dealer.data["dealership-details"].heartland_id}&price=${window.current_total_price}&year=${vehicle["@LISTING_YEAR"]}&make=${vehicle["@LISTING_MAKE"]}&model=${vehicle["@LISTING_MODEL"]}`}
                                    openLink={true}
                                    type="button"
                                    disabled={false}
                                    loading={false}
                                />
                            </div>
                        )}

                        {/*{(vehicle && currentFinanceOffer) &&  (*/}
                        {/*    <div class={`mt-4`}>*/}
                        {/*        <h5>Current Finance Offer</h5>*/}
                        {/*        <div className="popup-form__submit">*/}
                        {/*            <Button*/}
                        {/*                title={currentFinanceOffer.buttontext ? currentFinanceOffer.buttontext : "Current Offer"}*/}
                        {/*                modifiers={["solid", "medium", "full", currentFinanceOffer.form ? currentFinanceOffer.form : 'yellow']}*/}
                        {/*                href={currentFinanceOffer.link.url}*/}
                        {/*                openLink={currentFinanceOffer.icon == 'link' ? true : false}*/}
                        {/*                type="button"*/}
                        {/*                chevron={currentFinanceOffer.icon == 'chevron' ? true : false}*/}
                        {/*                disabled={false}*/}
                        {/*                loading={false}*/}
                        {/*            />*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*)}*/}
                    </div>

                    <div className="calculator__panel">
                        <div className="calculator__panel-main">
                            <div className="calculator__panel-head">
                                <div className="calculator__panel-price">
                                    <span>Your estimated weekly repayment: </span>
                                    <span>
                                        ${numeral(repayments).format("0,0")}pw
                                    </span>
                                </div>
                            </div>
                            <div className="calculator__panel-breakdown">
                                <div>
                                    <span>Deposit: </span>
                                    <span>
                                        ${numeral(iDeposit).format("0,0")}
                                    </span>
                                </div>
                                <div>
                                    <span>Loan Amount: </span>
                                    <span>
                                        ${numeral(iLoanAmount).format("0,0")}
                                    </span>
                                </div>

                                <div>
                                    <span>Fees: </span>
                                    <span>
                                        ${numeral(totalFees).format("0,0")}
                                    </span>
                                </div>
                                <div>
                                    <span>Interest: </span>
                                    <span>
                                        ${numeral(totalInterest).format("0,0")}
                                    </span>
                                </div>

                                <div className="calculator__panel-breakdown__total">
                                    <span>Total Cost: </span>
                                    <span>${numeral(total).format("0,0")}</span>
                                </div>
                                <div className="calculator__panel-breakdown__total">
                                </div>
                            </div>

                            <div className="calculator__panel-body">
                                <div
                                    className="calculator__panel-ts"
                                    dangerouslySetInnerHTML={{
                                        __html: termsEl
                                            ? termsEl.innerHTML
                                            : "",
                                    }}
                                ></div>
                            </div>
                        </div>
                        {/* <div className="calculator__panel-credit">
                            Armstrong’s finance driven by Heartland Bank
                        </div> */}
                    </div>
                </div>
            </Form>
        );
    };

    render() {
        const { ...rest } = this.props;
        const title = "Finance with Armstrongs";

        const initialValues = {
            vehiclePrice: this.state.vehiclePrice,
            deposit: this.state.deposit,
            financeRate: this.state.financeRate,
            years: this.state.years,
            firstName: "",
            lastName: "",
            phone: "",
            email: "",
            zapierUrl: window.location.href,
            message: "",
        };

        const validationSchema = Yup.object().shape({
            vehiclePrice: Yup.string().required("Required"),
            deposit: Yup.string().required("Required"),
            financeRate: Yup.number()
                .lessThan(MAX_INTEREST_RATE + 0.01,"Must be less than or equal to "+ MAX_INTEREST_RATE + "%")
                .moreThan(MIN_INTEREST_RATE - 0.01,"Must be more than or equal to "+ MIN_INTEREST_RATE + "%")
                .required("Required"),
            years: Yup.number()
                .moreThan(0, "Please enter a value more than 0")
                .required("Required")
            ,
            firstName: Yup.string().required("Required"),
            lastName: Yup.string().required("Required"),
            phone: Yup.string().required("Required"),
            email: Yup.string().required("Required"),
            message: Yup.string().required("Required"),
        });

        const vehicle = window.current_vehicle ?? null;
        const dealer = window.current_dealer ?? null;

        return (
            <Layout title={title} {...rest} vehicle={false} dealer={dealer}>
                {/* <form className="popup-form__form">
                    {this.renderForm(this.props)}
                </form> */}
                <p className={"popup-form__lead-text"}>
                    Enter the vehicle price, deposit amount and loan term to
                    quickly get an indication of how much your monthly
                    repayments are likely to be.
                </p>
                <Formik
                    isInitialValid={isInitialValid}
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={this.handleSubmit}
                    children={this.renderForm}
                />
            </Layout>
        );
    }
}

export default FormVehicleFinanceCalculator;

